/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getFullLink } from '../fn/short-link/get-full-link';
import { GetFullLink$Params } from '../fn/short-link/get-full-link';

@Injectable({ providedIn: 'root' })
export class ShortLinkService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFullLink()` */
  static readonly GetFullLinkPath = '/api/link/{linkUuid}';

  /**
   * Get Full Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFullLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFullLink$Response(params: GetFullLink$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getFullLink(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Full Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFullLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFullLink(params: GetFullLink$Params, context?: HttpContext): Observable<string> {
    return this.getFullLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
